import { request } from "./client";

/**
 * Consolidated Tenant Profile (Business Profile) API Service
 * 
 * Endpoints:
 * 1. GET  /bots/:botId/profile                  - Fetch bot profile & base64 logo (Protected)
 * 2. PUT  /bots/:botId/profile                  - Update heading, description, logo_data & logo_mime_type (Protected)
 * 3. POST /bots/:botId/profile/activate          - Activate bot profile for public view (Protected)
 * 4. POST /bots/:botId/profile/deactivate        - Deactivate bot profile from public view (Protected)
 * 5. GET  /public/tenants/:tenantId/profile     - Fetch active public profile & base64 logo (Public)
 * 6. GET  /tenants/profiles                     - Fetch list of all tenant profiles (Protected)
 * 7. GET  /public/tenants/profiles              - Fetch list of all public tenant profiles (Public)
 */

export const fetchTenantProfile = (tenantId) =>
  request(`/bots/${tenantId}/profile`, { skipCache: true });

export const updateTenantProfile = (tenantId, payload) =>
  request(`/bots/${tenantId}/profile`, {
    method: "PUT",
    data: payload,
  });

export const activateTenantProfile = (tenantId) =>
  request(`/bots/${tenantId}/profile/activate`, {
    method: "POST",
  });

export const deactivateTenantProfile = (tenantId) =>
  request(`/bots/${tenantId}/profile/deactivate`, {
    method: "POST",
  });

export const fetchPublicTenantProfile = (tenantId) =>
  request(`/public/tenants/${tenantId}/profile`, { skipCache: true });

export const getAllTenantProfiles = () =>
  request("/bots/profiles", { skipCache: true });

export const getAllPublicTenantProfiles = () =>
  request("/public/tenants/profiles", { skipCache: true });
